import { openCopilotChatDrawerMutator } from '../mutators/openCopilotChatDrawerMutator';
import { onCopilotChatDrawerLayoutChange } from '../actions/onCopilotChatDrawerLayoutChange';
import { updateCopilotChatDrawerPinnedPaneAction } from '../actions/updateCopilotChatDrawerPinnedPaneAction';
import { isCopilotChatDrawerShown } from '../selectors/isCopilotChatDrawerShown';
import { logCopilotChatSidePaneTelemetryEvent } from 'owa-copilot-telemetry/lib/copilotChatSidePaneTelemetryLogger';
import { getCurrentModule } from 'owa-app-module-store';

export function openCopilotChatDrawer(
    targetWindow: Window,
    customData?: {
        [key: string]: string;
    }
): void {
    if (isCopilotChatDrawerShown(targetWindow)) {
        // If already shown, no need to open again.
        // This happens if a caller tries too optimistically to open the drawer
        // without checking if it's already open.
        return;
    }

    logCopilotChatSidePaneTelemetryEvent('CopilotSidePane_BizChatOpened', {
        source: getCurrentModule(),
        isDrawerPane: true,
        ...customData,
    });

    openCopilotChatDrawerMutator(targetWindow);

    // Save the Copilot Chat Drawer as a pinned pane setting, for sticky open.
    // We do this only if we're in main window
    if (targetWindow === window) {
        onCopilotChatDrawerLayoutChange();
        updateCopilotChatDrawerPinnedPaneAction(true /* isSavingAsCopilotChatDrawer */);
    }
}
